import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldLike } from './utils';
import { DateField } from './schedule_utils';
import { fetchCSBDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';

class CSBDetailsForm extends Component {
    // static PropTypes = {
    //     onSubmit: PropTypes.func.isRequired,
    //     onCancel: PropTypes.func.isRequired,
    //     info: PropTypes.object.isRequired,
    //     setup: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            csbDetail: {},
            contract: {},
            activeTab: 'scope',
            isOpen: false,

        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

        const today = new Date();
        const targetYear = today.getFullYear() + 7;
        this.fiscalYears = [];

        let year;
        for (year = 2008; year <= targetYear; year++)
            this.fiscalYears.push({ label: year, value: year });
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        const { csbDetail } = this.props;
        this.setState({ csbDetail: csbDetail })
        this.props.fetchCSBDetails(contract.projectId, contract.contractId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.csbDetail !== nextProps.csbDetail)
            this.setState({ csbDetail: nextProps.csbDetail })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    handleCancel(e) {
        e.preventDefault();
        this.props.onCancel();
    }

    handleSubmit(e) {
        e.preventDefault();
        const { csbDetail } = this.state;
        this.setState({ csbDetail });
        this.props.onSubmit(csbDetail);
    }

    handleDateChange(name) {
        return (date) => {
            const csbDetail = { ...this.state.csbDetail, [name]: date }
            this.setState({ csbDetail });
        }
    }

    render() {
        const { csbDetail } = this.state;
        const { contract } = this.props;
        let canSubmit = true;

        return (
            <form className="clearfix" onSubmit={this.handleSubmit}>

                <div className="row static-modal-fields" >
                    <div id="csbform">

                        <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                            <div className="bar-bottom prjinfo">INFO</div>
                            <div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Registration #" value={csbDetail.regNumber} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Pin #" value={csbDetail.pinNumber} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Vendor Name" value={csbDetail.contractor} />
                                </div>

                                <div className="col l4 m3 s6">
                                    <FieldLike label="Contract Status" value={csbDetail.contractStatus} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Contract Type" value={csbDetail.contractType} />
                                </div>
                            </div>
                        </div>
                        <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                            <div className="bar-bottom prjinfo">DATES</div>
                            <div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Contract Start Date" value={getDateValue(csbDetail.origContractStartDate)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Contract End Date" value={getDateValue(csbDetail.origContractCompleteDate)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Bid Avertising Date" value={getDateValue(csbDetail.cnstrProcBidAdvDt)} />
                                </div>
                                {contract.contractType.includes('Construction/') ?
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Original Bid Due Date" value={getDateValue(csbDetail.cnstrProcOrigBidDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Amended Bid Due Date" value={getDateValue(csbDetail.cnstrProcAmndBidDt)} />
                                        </div>
                                    </div>
                                    : null}
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Award Date" value={getDateValue(csbDetail.awardDate)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Pre-Award Date" value={getDateValue(csbDetail.preAwardActualEnd)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="NTP Date" value={getDateValue(csbDetail.noticeToProceedDate)} />
                                </div>
                                {this.props.contract.divisionName === 'Infrastructure' ?
                                    <div className="col l4 m3 s6">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Revised NTP Date</span>
                                            {/* <label>Revised NTP</label> */}
                                            <DateField name="revisedNTPDt"
                                                value={csbDetail.revisedNTPDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('revisedNTPDt')}
                                            />
                                        </div>
                                    </div> : null}
                            </div>
                        </div>
                        <div className="col s12 padding-right-0 padding-left-0 margin-top-075">
                            <div className="bar-bottom prjinfo">AMOUNT</div>
                            <div >
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Contract Original Award Amount" value={formatMoney(csbDetail.origContractAmount)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Current Registered Amount" value={formatMoney(csbDetail.current_Registered_Amount)} />
                                </div>
                                <div className="col l4 m3 s6">
                                    <FieldLike label="Current Award Amount" value={formatMoney(csbDetail.currentContractAmount)} />
                                </div>
                                {contract.contractType.includes('Construction/') ?
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Estimated Bid Amount" value={formatMoney(csbDetail.estimated_Bid_Amount)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="First Low Bid Amount" value={formatMoney(csbDetail.first_Low_Bid_Amount)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Second Low Bid Amount" value={formatMoney(csbDetail.second_Low_Bid_amount)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Bid Amount" value={formatMoney(csbDetail.bidAmount)} />
                                        </div>
                                    </div>
                                    : null}

                            </div>
                        </div>
                        {/* <div ref="test" className="col s12"></div> */}

                    </div>
                </div>


                <div className="section-buttons ttt" id="sectionBtnsInfo">
                    <span className="btn-cancel" onClick={this.handleCancel}>Cancel</span>
                    <button className="btn-save" disabled={!canSubmit}>Save</button>
                </div>
            </form>
        );
    }
}

CSBDetailsForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired,
    setup: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        csbDetail: state.additionalProjectsStore.csbDetail[0],
        projectId: ownProps.projectId,
    }
}

export default connect(mapStateToProps, { fetchCSBDetails })(CSBDetailsForm);